import Col from '@loggi/ui/components/col';
import Text from '@loggi/ui/components/text';
import Icon from '@loggi/ui/components/icon';
import icons from '@loggi/ui/components/utils/icons';
import PropTypes from 'prop-types';
import React from 'react';
import { messageTextsComplementaryInfoLayout } from './confirm-delivery.constants';

export default function LocalInfo({ localText }) {
  return (
    <Col>
      <Col className="delivery-info-ico">
        <Icon type={icons.type.SHOP} />
        <Text>{messageTextsComplementaryInfoLayout.LOCAL_TEXT}</Text>
      </Col>
      <Col className="delivery-data">
        <Text>{localText}</Text>
      </Col>
    </Col>
  );
}

LocalInfo.displayName = 'LocalInfo';

LocalInfo.propTypes = {
  localText: PropTypes.string.isRequired
};
